module.exports = __webpack_public_path__ + "img/logo.297e6712.png";